/* eslint-disable no-empty */
/* eslint-disable no-prototype-builtins */
import Vue from 'vue'
import Vuex from 'vuex'
import Labels from './modules/labels'
import VuexEasyFirestore from 'vuex-easy-firestore'
import { Firebase, initFirebase } from '../Firebase.js'
import colors from 'vuetify/lib/util/colors'
// eslint-disable-next-line no-unused-vars
import { arrayUnion } from 'vuex-easy-firestore'
const axios = require('axios')

Vue.use(Vuex)

function convertidata(value) {
  console.log("CONVERTO DATA", value)

  var date = new Date(value)
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var dt = date.getDate()

  if (dt < 10) {
    dt = '0' + dt
  }
  if (month < 10) {
    month = '0' + month
  }
  return year + '-' + month + '-' + dt
}

function groupBy(xs, key) {
  
  console.log("GROUPBY",xs, key);
  if(Array.isArray(xs)){
    return xs.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }
  else{
    var r =[];
    r[key] = xs;
    return r;
  }

}

import precheckins from './modules/precheckins.js'
import reservations from './modules/reservations.js'
import messages from './modules/messages.js'
import comuni from './modules/comuni.js'
//import { isArray } from 'core-js/fn/array'
const easyFirestore = VuexEasyFirestore(
  [precheckins,reservations,messages,comuni],
  { logging: true, FirebaseDependency: Firebase }
)


const store = new Vuex.Store({
  plugins: [easyFirestore],
  modules: {
    Labels
  },
  state: {
    user: {
      loggedIn: false,
      data: null
    },
    carrello:{
      piatti:[]
    },
    contrattofirmato:false,
    drawer: false,
    nospiti:0,
    appmenuenabled:true,
    mostrafootermenu:false,
    guidmenu:null,
    fcmtoken: null,
    count: 1,
    schedaospitevisibile: true,
    settings: {
      apiurl: 'https://precheckinapi.herokuapp.com/api',
      apiurl__: 'http://localhost:4000/api',
      apiurl2: 'http://localhost:3000',
      iditalia: 100000100,
      apipwd: { name: 'Nick Cerminara', password: 'password' },
      token: "",
      HRAPIURL: 'https://beta.hotelrunner.it/hrapi/API',
      APIKEY: '',
    },
    countries: [],
    currentlan: 'it',
    privacyaccepted: false,
    texts:
    {
      home:
      {
        title: 'Benvenuto',
        image: '',
        logo: "",
        description: 'Descrizione',
        buttontext: 'salva',
      },
    },
    labels:
    {
      firstname: 'name',
      lastname: 'cognome',
      gender: 'sesso',
      dateofbirth: 'data di nascita',
      countryofbirth: 'stato di nascita',
      cityofbirth: 'comune di nascita',
      countryofresidence: 'stato di residenza',
      cityofresidence: 'comune di residenza',
      citizenship: 'cittadinanza',
      cityofissue: 'città di rilascio',
      countryofissue: 'stato di rilascio',
      addressofresidence: 'indirizzo di residenza',
      documenttype: 'tipo di documento',
      documentnumber: 'numero documento',
      dayofissue:'giorno di rilascio',
      monthofissue:'mese di rilascio',
      yearofissue:'anno di rilascio',
      dayofexpiration:'giorno di scadenza',
      monthofexpiration:'mese di scadenza',
      yearofexpiration:'anno di scadenza',
      issueby:'ente di rilascio',
      email: 'email'
    },
    config: {
      HotelName: '',
      WelcomeText: 'benevenuto ....',
      PrivacyText: 'qui ci va la <b>privacy</b>',
      ContractText: '',
      BackgroundImageUrl: '',
      LogoImageUrl: '',
      GoodbyeText: '',
      AlphaLogo: 0.7,
      CanAddGuest: 0,
      Bacheca:false,
      Menu:false,
      Messaggi:false,
      Pagamenti:false,
      Precheckin:false,
      EstrattoConto:false
    },
    config2: {},
    reservation: {
      id: '0',
      checkin: '08-16',
      checkout: '08-22',
      nights: 6,
      rooms: [],
      ref: '',
      notes: '',
      status: '',
      privacy:[],
      other:{
        privacy:[],
      },
      mainguest: {
        id: 1,
        firstName: 'ospite',
        lastName: 'principale_store',
        image: '',
        gender: 'M',
        dateofbirth: '',
        countryofbirth: { Codice: 100000100, Descrizione: "ITALIA" },
        countryofresidence: { Codice: 100000100, Descrizione: "ITALIA" },
        citizenship: '',
        cityofresidence: '',
        cityyofbirth: '',
        ismodified: false,
        iscompiled: false,
        roomid: '215',
        issueby:''
      },
      visitors: [
        {
          id: 23,
          firstName: 'luigi',
          lastName: 'naspi',
          gender: 'M',
          roomid: '1',
          ismodified: false,
          iscompiled: false,
        }
      ]
    }
  },
  actions: {
    /* *************** gestione dei menu ******************/
    ordinapiatto({ commit }, piatto) {
      return new Promise((resolve) => {
        commit('ORDINAPIATTO', piatto);
        resolve();
      })
    },

    rimuovipiatto({ commit }, piatto) {
      return new Promise((resolve) => {
        commit('RIMUOVIPIATTO', piatto);
        resolve();
      })
    },
    azzeramenu({commit}){
      return new Promise((resolve) => {
        commit('AZZERAMENU');
        resolve();
      })
    },

    /* *************fine gestione dei menu *****************/
        // eslint-disable-next-line no-unused-vars
    UpdateComuniFromHR({ commit, dispatch }) {
      if(!this.state.comuni2 || (this.state.comuni2 && this.state.comuni2.length<7000)) //se non ho ancora caricato i comuni lo carico
      {
          return new Promise((resolve, reject) => {
                           
                var URL = 'https://beta.hotelrunner.it/GestionaleCheckinHR/CompCheckin/Funzioni'
                // Make a request for a user with a given ID
                /*axios({
                  method: 'POST',
                  url: URL,
                  headers: { 
                  'content-type': 'application/json',
                  'X-HTTP-Method-Override': 'GETCOMUNIJSON',
                  'idcliente': '1225EC37-8FD3-4DEE-B5A9-B6D034D89468',
                  'username': 'marco',
                  'password': 'marco*123' },
                  data: {lingua:'' }
        
                })*/
                URL='https://firebasestorage.googleapis.com/v0/b/precheckin-1466b.appspot.com/o/service%2Fcomuni_min.json?alt=media&token=c0fc8273-fef8-4287-a855-03b39a4a3724'
                axios({
                  method: 'GET',
                  url: URL, 
                }).then(response => {
                  // http success, call the mutator and change something in state
                  commit('SET_TUTTI_COMUNI',response.data.comuni)
                 

              /*
              let c = {id:'comuni','items':response.data.comuni}
              console.log("risposta comuni ->", c)

              dispatch('comuni/insertBatch', response.data.comuni)
              .then(x=>{
                console.log('fine inserimento comuni',x)
              })
              .catch(err=>{
                console.log('errore inserimento comuni',err)
              })
              */


              /*
              for (const key in response.data.comuni) {
                if (response.data.comuni.hasOwnProperty(key)) {
                  const element = response.data.comuni[key];
                  element.id=element.Codice+''
                  dispatch('comuni/set',element)
                }
              }
              */
              
              //dispatch('daticomuni/set',c)
              resolve(response);  // Let the calling function know that http is done. You may send some data back
              
            }, error => {
              // http failed, let the calling function know that action did not work out
              reject(error);
            }

            )
          })
        }
        else{
          return new Promise((resolve) => {resolve()})
        }
        },

    updateValueAction({ commit }, value) {
      commit('updateValue', value)
    },
    setprivacy({ commit }, value) {
      return new Promise((resolve) => {
        commit('setprivacyaccepted', value)
        resolve();
      })
      
    },
    setguidmenuAction({ commit }, value) {
      return new Promise((resolve) => {
        commit('setguidmenu', value)
        resolve();
      })
      
    },
    setappmenuvisibleAction({ commit }, value) {
      return new Promise((resolve) => {
        commit('setappmenuvisible', value)
        resolve();
      })
      
    },
    // eslint-disable-next-line no-unused-vars
    APIRequestHR({ commit }, payload) {
      return new Promise((resolve, reject) => {
        var URL = this.state.settings.HRAPIURL
        
        let token = this.state.settings.APIKEY?this.state.settings.APIKEY:''
        let idckol = this.getters.reservationid?this.getters.reservationid:''
        let guidmenu = this.state.guidmenu?this.state.guidmenu:''

        if (guidmenu.length > 0){
          token =''
          idckol =''
        }
        if(payload.idckol){
          idckol = payload.idckol
        }

        const heads = { 'content-type': 'application/json', 'X-HTTP-Method-Override': 'APIRequest', 
          'token': token,
          'idckol': idckol, 
          'guidmenu': guidmenu}
        console.log("APIrequest",URL, this.state.settings.APIKEY, JSON.stringify(payload), heads)
        var bodyFormData = new FormData();
        bodyFormData.set('Param', JSON.stringify(payload));
        // Make a request for a user with a given ID
        axios({
          method: 'POST',
          url: URL,
          headers: heads,
          data:  bodyFormData

        }).then(response => {
          // http success, call the mutator and change something in state Param: JSON.stringify(
          resolve(response);  // Let the calling function know that http is done. You may send some data back
        }, error => {
          // http failed, let the calling function know that action did not work out
          console.error("ERRORE",payload,error)
          reject(error);
        })
      })
    },
    fetchUser({ commit }, user) {
      //commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", user);
      } else {
        commit("SET_USER", null);
      }
    },
    // eslint-disable-next-line no-unused-vars
    updateFcmToken({ commit, dispatch }, value) {
      return new Promise((resolve, reject) => {
        try {
          //let doc = Firebase.firestore(). .Collection("reservations").Document(this.getters.reservationid)
          //doc.update({ "fcmtokens": Firebase.firestore.FieldValue.arrayUnion(value) });
          let pl ={id:this.getters.reservationid,fcmtoken:value,user:this.getters.user}
          commit('SET_FCMTOKEN', value);
          
          dispatch(`reservations/set`, pl)
            .then(x=>{
              console.log(x)
            })
            
          resolve()
        } catch (error) {
          reject(error);
        }
      })

    },
    // eslint-disable-next-line no-unused-vars
    sendMessage({ commit, dispatch }, value) {
      console.log('sendmsg0')
      return new Promise((resolve, reject) => {
        try {
          dispatch(`messages/setPathVars`, {reservationId: this.getters.reservationid})
          .then(y=>{
            dispatch(`messages/set`, value)
            .then(x=>{
              console.log(x,y)
            })
          })

            
          resolve()
        } catch (error) {
          reject(error);
        }
      })

    },
    // eslint-disable-next-line no-unused-vars
    set_HRAPIURL({ commit, dispatch }, reservation) {
          console.log('sendmsg0', reservation)
          // eslint-disable-next-line no-unused-vars
          if(reservation.config.URLHRAPI){
            this.commit('setHRAPIURL', reservation.config);
          }

          return new Promise((resolve) => {
            
            //modifica del 17.03.2021 la configurazione viene presa via APIREQUEST
            // eslint-disable-next-line no-constant-condition
            if (reservation.ConfigUrl && reservation.ConfigUrl != '' && false) {
              //ottengo i testi personalizzati
              Vue.http.get(reservation.ConfigUrl.replace('http://', 'https://').replace('webhotel.quasarsoft.it', 'beta.hotelrunner.it') + '&IdPren=' + reservation.pmsid)
                .then(resp => {
                      console.log('RISP TESTI STRUTTURA',reservation.ConfigUrl, resp.body)
      
                      if(resp.body.ConfigCO){
                        for (let index = 0; index < resp.body.ConfigCO.length; index++) {
                          const element = resp.body.ConfigCO[index];
                          this.commit('settraduzioni', element)
                          this.commit('setHRAPIURL', element)
                          
                        }
                        console.log('RISP TESTI STRUTTURA2');
                      }
                      if(resp.body.ElencoConfig){
                        for (let index = 0; index < resp.body.ElencoConfig.length; index++) {
                          const element = resp.body.ElencoConfig[index];
                          this.commit('settraduzioni', element)
                          this.commit('setHRAPIURL', element)
                        }
                        console.log('RISP TESTI STRUTTURA3');
                      }
      
                      resolve();
              })
              .catch(error => {
                resolve(error);
                //reject(error);
              });
            } else {
              var ele = {
                WelcomeText: reservation.config.WelcomeText,
                GoodbyeText: reservation.config.GoodbyeText,
                PrivacyText: reservation.config.PrivacyText,
                ContractText: reservation.config.ContractText,
                LINGUA: 'IT'
              }
              this.commit('settraduzioni', ele)
              console.log('RISP TESTI STRUTTURA4');
              resolve();
            }


          })
    
        },
    setreservation({ commit, dispatch }, id) {
      
      var thisp = this;
      return new Promise((resolve, reject) => {
        console.log(thisp.state.settings.apiurl);
        Vue.http.get(thisp.state.settings.apiurl + "/reservations/" + id, {}).then(resp => {
          console.log("RISP reservation->", resp);
          //Object.assign(this.alldata.reservation.mainguest, resp.body);
          commit('SETRESERVATION', resp.body);
          dispatch("set_HRAPIURL",resp.body)
            .then(r=>{
              console.log("RISP reservation->>",r,this.state.settings.HRAPIURL );

              //Carico configurazione da hotel runner
              dispatch("APIRequestHR",{ idckol:id, Comando: "GetDatiConfigCO" }).then(x=>{
                console.log('GetDatiConfigCO',x)
                commit('SET_CONFIG2', x.data.RISULTATOJSON.ElencoConfig);
                var config_in_lingua = x.data.RISULTATOJSON.ElencoConfig;
                
                for (let index = 0; index < config_in_lingua.length; index++) {
                  const element =config_in_lingua[index];
                  this.commit('settraduzioni', element)
                  this.commit('setHRAPIURL', element)
                  
                }
                console.log("carico prenotazione HR,",id)
                dispatch("APIRequestHR",{idckol:id,Comando:"GetPrenotazione"}).then(x=>{
                  console.log('GetPrenotazioneHR',x)
                  commit('SET_PRENOTAZIONEHR', x.data.RISULTATOJSON);
                  
                  commit('SETRESERVATION', resp.body);
                  dispatch("updateFcmToken")
                  resolve(resp.body)
                })
      
    
    
    
              })
            })







        })
          .catch(error => {
            reject(error);
          });

      })

    },
    // eslint-disable-next-line no-unused-vars
    logout({ commit, dispatch }){
      return new Promise((resolve, reject) => {
        Firebase.auth().signOut().then(function() {
          resolve()
        }).catch(function(error) {
          reject(error);
        });

    })},
    // eslint-disable-next-line no-unused-vars
    closeReservation({ commit, dispatch }, value) {
      console.log('avvio closeReservation')
      return new Promise((resolve, reject) => {
        try {
          
          Vue.http.put(this.state.settings.apiurl + '/reservations/' + this.state.reservation._id + '/close', this.state.reservation
          ).then(resp => {
            console.log('risposta a closeReservation',resp)
            commit("closeReservation")
          })

            
          resolve()
        } catch (error) {
          reject(error);
        }
      })

    },
    setContrattofirmato({ commit }, value) {
      return new Promise((resolve) => {
        commit('setContrattofirmato', value)
        resolve();
      })
      
    },
    // eslint-disable-next-line no-unused-vars
    EseguiOCRDoc({ commit }, payload) {
      return new Promise((resolve, reject) => {
        var URL = "https://ocrdocumenti.azurewebsites.net/api/ExtractData?code=frnHDHX849975Q9xkNhHPFkAi1F_gWl51vsanKf3l2nuAzFukExxXQ%3D%3D"
        
        let token = this.state.settings.APIKEY?this.state.settings.APIKEY:''
        let idckol = this.getters.reservationid?this.getters.reservationid:''
        let guidmenu = this.state.guidmenu?this.state.guidmenu:''

        // TODO aggiungere secureKey al body per permettere il riconoscimento

        if (guidmenu.length > 0){
          token =''
          idckol =''
        }
        if(payload.idckol){
          idckol = payload.idckol
        }

        const heads = { 'content-type': 'application/json', 
          'token': token,
          'idckol': idckol, 
          'guidmenu': guidmenu}
        console.log("APIrequest",URL, this.state.settings.APIKEY, JSON.stringify(payload), heads)
        var bodyFormData =  JSON.stringify(payload)
        // Make a request for a user with a given ID
        axios({
          method: 'POST',
          url: URL,
          headers: heads,
          data:  bodyFormData

        }).then(response => {
          // http success, call the mutator and change something in state Param: JSON.stringify(
          resolve(response);  // Let the calling function know that http is done. You may send some data back
        }, error => {
          // http failed, let the calling function know that action did not work out
          console.error("ERRORE",payload,error)
          reject(error);
        })
      })
    },
  },
  mutations: {
    SET_HRAPIURL(state,objconf){
      console.log("SET_HRAPIURL HRAPIURL")
      state.settings.HRAPIURL = objconf.URLHRAPI;
      console.log('RISP TESTI STRUTTURA HRAPIURL',objconf.URLHRAPI,objconf);
    },
    SET_DRAWER(state) {
      state.drawer = !state.drawer
    },
    ORDINAPIATTO(state, piatto){
      //console.log("ordina_store", piatto);
      state.carrello.piatti.push(Object.assign({},piatto));
      //console.log("ordina_store_carrello:", state.carrello);

      state.nospiti = 0;
      if(state.reservation){
        state.nospiti =state.reservation.visitors.length + 1
      }
      if (!piatto.ordinato) piatto.ordinato = 0;
      piatto.ordinato++;

      

      piatto.sottogruppo.ordinato++;
      piatto.sottogruppo.canadd =
      state.nospiti - piatto.sottogruppo.ordinato > 0;

      //per far effettuare refresh
      let bkp = piatto.sottogruppo.idsottogruppo;
      piatto.sottogruppo.idsottogruppo = -1;
      piatto.sottogruppo.idsottogruppo = bkp;
      
    },
    RIMUOVIPIATTO(state, piatto){
      //console.log("_store", piatto);
      state.nospiti = 0;
      if(state.reservation){
        state.nospiti =state.reservation.visitors.length + 1
      }
      state.carrello.piatti.splice(state.carrello.piatti.indexOf(piatto), 1);
      piatto.ordinato--;

      piatto.sottogruppo.ordinato--;
      piatto.sottogruppo.canadd =
      state.nospiti - piatto.sottogruppo.ordinato > 0;

      //per far effettuare refresh
      let bkp = piatto.sottogruppo.idsottogruppo;
      piatto.sottogruppo.idsottogruppo = -1;
      piatto.sottogruppo.idsottogruppo = bkp;
    },
    AZZERAMENU(state){
      console.log("azzero piatti")
      state.carrello.piatti=[]
    },

    SET_TUTTI_COMUNI(state, value) {
      
      state.comuni2 = value.map(function(val) {
        return {
            Codice:  val.c,
            Descrizione: val.d 
        };
    });
      console.log("SET_TUTTI_COMUNI",value,state.comuni2)
    },
    SET_CONFIG2(state, value) {
      state.config2 = value;
      state.config= value[0];

      //Aggiorno il valore della variabile HRAPIURL per gestire installazioni diverse da quella principale
      state.settings.HRAPIURL = state.config.URLHRAPI.replace("http://","https://")+"API";
    },
    SET_PRENOTAZIONEHR(state, value) {
      state.prenotazionehr = value;
      state.contrattofirmato = (value.ContrattoURL && value.ContrattoURL!="")
      console.log("RISORSE - pre:",state.reservation.other.risorse,value)
      if(value.Risorse)
      {
        state.reservation.other.risorse =[]
        value.Risorse.forEach(element => {
          console.log("RISORSE - add:",element)
          state.reservation.other.risorse.push({Descrizione:element.DescrizioneRisorsa,RoomID:element.IdPrenotazioneRisorsa})
        });
      }
      console.log("RISORSE - post:",state.reservation.other.risorse)
      
    },
    SET_FCMTOKEN(state, value) {
      state.fcmtoken = value;
    },
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.firebaseuser = data;
    },
    updateValue(state, value) {
      state.value = value
      console.log('STORE - updatevalue', state, value)
    },
    increment(state) {
      state.count++
      console.log('STORE', state.count)
    },
    setappmenuvisible(state, value) {
      state.appmenuenabled = value
    },
    setnumberofguests(state, value) {
      state.reservation.nospiticheckin = value
      console.log("setnumberofguests",value,state.reservation.visitors)
      if(value < state.reservation.visitors.length ){
        state.reservation.visitors.length = value - 1
      }
      else{
        for (let index = state.reservation.visitors.length+1; index < value; index++) {
          let new_osp ={
            id: index,
            firstName: '',
            lastName: '',
            gender: '',
            roomid: state.reservation.mainguest.roomid,
            ismodified: false,
            iscompiled: false,  
          }
          console.log("ospite_aggiunto",value,state.reservation.visitors)
          state.reservation.visitors.push(new_osp);
        }
      }
      
      console.log("imposto numero ospiti:", state.reservation.visitors.length)
    },
    settraduzioni(state, obj) {
      console.log("lingu ----> ", obj)
      console.log("lingua ->>>> ", obj.LINGUA.toLowerCase())
      var lingua = obj.LINGUA.toLowerCase();
      if (lingua == 'nl') lingua = 'en';
      if (lingua == '') lingua = 'it';
      state.Labels[lingua].WelcomeText = obj.WelcomeText;
      state.Labels[lingua].GoodbyeText = obj.GoodbyeText;
      state.Labels[lingua].PrivacyText = obj.PrivacyText;
      state.Labels[lingua].ContractText = obj.ContractText;

    },
    setHRAPIURL(state, obj) {
      //aggiorno l'url per poter funzionare su tutte le installazioni diverse da beta
      //state.settings.HRAPIURL = obj.URLHRAPI;
      state.settings.HRAPIURL = obj.URLHRAPI.replace("http://","https://")+"API";
      state.settings.HRAPIURL = obj.URLHRAPI.replace("http://","https://")+"API";
    },
    setcurrentlan(state, obj) {
      console.log('setting language...', obj)
      /*
      Vue.http.get(state.settings.apiurl2 + '/labels/' + obj, {}
      ).then(resp => {
        console.log('RISP lables', resp)
        state.labels = resp.body.items
      })*/

      state.labels = []
      state.labels = state.Labels.it
      state.currentlan = obj
      if (obj == 'it') {
        state.labels = state.Labels.it
      }
      if (obj == 'en') {
        state.labels = state.Labels.en
      }
      if (obj == 'fr') {
        state.labels = state.Labels.fr
      }
      if (obj == 'de') {
        state.labels = state.Labels.de
      }
      if (obj == 'es') {
        state.labels = state.Labels.es
      }
      if (obj == 'nl') {
        state.labels = state.Labels.en
      }



      //carico gli stati in lingua
      const apiurl = 'https://quasar-api.firebaseio.com/common_data/countries/';
      const lingua = state.currentlan;
      console.log('esecuzione GET... per countries');
      Vue.http.get(apiurl + lingua + '.json').then((resp) => {
        console.log('RISP', resp);
        state.countries = [];
        // this.countries = resp.body
        const stati_tradotti = resp.body.countries.map((obj) => {
          const rObj = {};
          rObj.Codice = Number(obj.code);
          rObj.Descrizione = obj.name.toUpperCase();
          rObj.iso_2 = obj.iso_2;
          rObj.iso_3 = obj.iso_3;
          rObj.nationality = obj.nationality;
          return rObj;
        });
        // state.countries = stati_tradotti;
        state.countries = [].concat(state.countries, stati_tradotti);
        console.log('carico stati', stati_tradotti);
      });


    },

    SETRESERVATION(state, reservation) {
      console.log('Aggiornamento stato per', reservation)
      //state.config = reservation.config  //ora la configurazione viene acquisita SET_CONFIG2
      if (!state.config.themecolor) {
        state.config.themecolor = colors.blue.darken1
      }
      if(!reservation.visitors){
        reservation.visitors=[];
      }
      else{
        if(!Array.isArray(reservation.visitors)){
          let a=[];
          a.push(reservation.visitors);
          reservation.visitors =a;
        }
      }
      
      
      if (reservation.visitors.length > 0) {
        for (var key in reservation.visitors) {
          // eslint-disable-next-line no-prototype-builtins
          if (reservation.visitors.hasOwnProperty(key)) {
            var element = reservation.visitors[key]
            element.dateofbirth = convertidata(element.dateofbirth)
            var d = new Date(element.dateofbirth)
            element.yearofbirth = d.getFullYear()
            element.monthofbirth = d.getMonth() + 1
            element.dayofbirth = d.getDate()
            element.ismodified = false
            element.iscompiled = false
            element.id = state.count
            if (!element.firstName && !element.lastName)
              //element.firstName ="guest " +element.id
              if (!element.lastName || element.lastName == "" || element.yearofbirth == 1900) {
                element.dateofbirth = null
                element.dayofbirth = null
                element.monthofbirth = null
                element.yearofbirth = null
              }

            state.count++
          }
        }

      }


     /********XXXXX***** */   

      console.log('ETICHETTE', state.Labels)
      state.labels = []
      state.labels = state.Labels.it
      console.log("imposto lingua prenotazione")
      if (reservation.language) {
        this.commit('setcurrentlan', reservation.language.toLowerCase())
      } else {
        this.commit('setcurrentlan', 'it')
      }


      // converto datanasc maingest
      reservation.mainguest.dateofbirth = convertidata(reservation.mainguest.dateofbirth)
      d = new Date(reservation.mainguest.dateofbirth)
      reservation.mainguest.yearofbirth = d.getFullYear()
      reservation.mainguest.monthofbirth = d.getMonth() + 1
      reservation.mainguest.dayofbirth = d.getDate()
      reservation.mainguest.id = state.count
      reservation.mainguest.ismodified = true
      reservation.mainguest.iscompiled = false
      console.log("MAINGUEST:", reservation.mainguest)
      if (!reservation.mainguest.firstName && !reservation.mainguest.lastName)
        reservation.mainguest.firstName = reservation.ref
      if (!reservation.mainguest.lastName || reservation.mainguest.lastName == "" || reservation.mainguest.yearofbirth == 1900) {
        reservation.mainguest.dateofbirth = null
        reservation.mainguest.yearofbirth = null
        reservation.mainguest.monthofbirth = null
        reservation.mainguest.dayofbirth = null
        console.log("datavuota")
      }

      state.count++
      reservation.checkin = convertidata(reservation.checkin)
      reservation.checkout = convertidata(reservation.checkout)

      var a = groupBy(reservation.visitors, 'roomid');
      reservation.rooms = a;
      reservation.rooms[reservation.mainguest.roomid] = 'camera capo';
      console.log("STANZAE", a);

      state.reservation.id = state.reservation._id
      state.reservation = reservation
      console.log('setreservationid', reservation._id)
      localStorage.setItem('reservationid', reservation._id);

    },
    setmainguest(state) {
      state.reservation.mainguest.firstName = 'genoveffA'
      console.log('setmainguest', state.count)
    },
    clearreservationid(state) {
      state.reservation = null
      console.log('setreservationid', null)
      localStorage.setItem('reservationid', null);
    },
    setguidmenu(state,value) {
      state.guidmenu = value
    },
    setprivacyaccepted(state, listaconsensi) {

      state.privacyaccepted = true
      /*const array = this.getters.privacyfinalita
      console.log('privacy item - ', array)
      let fin =[];
      for (let index = 0; index < array.length; index++) {
        fin.push({id:array[index].IdFinalita,accepted:array[index].accettato})
      }
      */
      console.log('privacy accettata', listaconsensi)
      if(!state.reservation.other) {
        state.reservation.other={}
      }
        
      state.reservation.other.privacy = listaconsensi;
    },
    setContrattofirmato(state, urlcontratto) {

      state.contrattofirmato = true
      console.log('contrattofirmato', urlcontratto)
    },
    
    auth(state) {
      console.log('autenticazione in corso...')
      Vue.http.options.xhr = { withCredentials: true }
      console.log('autenticazione in corso 2...')
      Vue.http.post(state.settings.apiurl + '/authenticate', state.settings.apipwd
      ).then(resp => {
        console.log('Esito Autenticazione 1 ', resp)
        state.settings.token = resp.body.token
        console.log('Esito Autenticazione', state.settings.token)
      })
    },
    updateMainguest(state, message) {
      console.log("STATE", state)
      console.log('UPDATE mainguest: ', message)
      var trace = { Tipo: "UPDATE mainguest", Descrizione: JSON.stringify(message), ReservationId: state.reservation._id }
      Vue.http.post(state.settings.apiurl + '/errors', trace)

      message.ismodified = false
      message.iscompiled = true
      state.schedaospitevisibile = false;
      Object.assign(state.reservation.mainguest, message)

      //controllo la data di nascita degli ospiti altrimenti fallisce la memorizzazione
      var reservation = state.reservation;
      if (reservation.visitors &&reservation.visitors.length > 0) {
        for (var key in reservation.visitors) {
          if (reservation.visitors.hasOwnProperty(key)) {
            var element = reservation.visitors[key]
            var d = element.dateofbirth;
            // eslint-disable-next-line no-empty
            if (d instanceof Date && !isNaN(d)) {
            } else {
              element.dateofbirth = new Date();
            }

          }
        }
      }
      console.log("aggiornocon",JSON.stringify(state.reservation))
      Vue.http.put(state.settings.apiurl + '/reservations/' + state.reservation._id, state.reservation
      ).then(resp => {
        console.log('RISP updateGuest', resp)
        if (resp.ok == true) {
        } else {
          message.iscompiled = false
          Object.assign(state.reservation.mainguest, message)
          var trace = { Tipo: "ERROR mainguest", Descrizione: resp.body, ReservationId: state.reservation._id }
          Vue.http.post(state.settings.apiurl + '/errors', trace)
          console.log(trace)
        }

      }).catch(err => {
        var trace = { Tipo: "ERROR mainguest", Descrizione: JSON.stringify(err), ReservationId: state.reservation._id }
        Vue.http.post(state.settings.apiurl + '/errors', trace)
        console.error(trace)
        console.error(err);
      })


    },
    updateGuest(state, message) {
      if (message) {
        console.log('Cerco...->', state.reservation)
        console.log('update con...->', message)
        var i = state.reservation.visitors.findIndex(x => x.id === message.id)
        console.log('TROVATO', i)
        if (i >= 0) {

          message.iscompiled = true
          message.ismodified = false
          state.schedaospitevisibile = false;
          state.reservation.visitors.splice(i, 1, message)
          Vue.http.put(state.settings.apiurl + '/reservations/' + state.reservation._id, state.reservation
          ).then(resp => {
            console.log('RISP updateGuest', resp)
            if (resp.ok == true) {

              console.log('api url:', state)
            }
            else {
              var trace = { Tipo: "ERROR guest", Descrizione: resp.body, ReservationId: state.reservation._id }
              Vue.http.post(state.settings.apiurl + '/errors', trace)
            }
          }).catch(err => {
            var trace = { Tipo: "ERROR guest", Descrizione: JSON.stringify(err), ReservationId: state.reservation._id }
            Vue.http.post(state.settings.apiurl + '/errors', trace)
            console.error(err);
          })
        }
      }
    },
    updateReservation(state, { dispatch }) {
      Vue.http.put(state.settings.apiurl + '/reservations/' + state.reservation._id, state.reservation
      ).then(resp => {
        console.log('RISP updateGuest', resp)
      })
      dispatch('precheckins/set', state.reservation)
    },
    closeReservation(state) {
      state.reservation.status = 'CLOSED'
    },
    removeGuest(state, message) {
      if (message) {
        console.log('Cerco per eliminare...', message.id)
        var i = state.reservation.visitors.findIndex(x => x.id === message.id)
        console.log('TROVATO', i)
        state.reservation.visitors.splice(i, 1)
      }
    },
    editGuest(state, message) {
      if (message) {
        console.log('Cerco per modificare...', message.id)
        var i = state.reservation.visitors.findIndex(x => x.id === message.id)
        console.log('TROVATO', i)
        state.reservation.visitors.forEach(function (element) {
          element.ismodified = false
        })
        state.reservation.mainguest.ismodified = false
        if (i >= 0) {
          var guest = state.reservation.visitors[i]
          guest.ismodified = true
          state.schedaospitevisibile = true
          state.reservation.visitors.splice(i, 1, guest)
          console.log('ASSEGNO MODIFICATO', i)
        }
      }
    },
    editNextGuest(state, message) {
      if (message) {
        console.log('Cerco il prossimo...', message.id)
        var i = -1
        var guest = null;

        if (message.isprimary) { // se provengo dal capofamiglia seleziono il primo accompagnatore se presente
          if (state.reservation.visitors.length > 0) {
            i = 0;
            guest = state.reservation.visitors[0]
          }
        }
        else {
          var prossimo = message.id + 1
          i = state.reservation.visitors.findIndex(x => x.id === prossimo)
        }


        state.reservation.visitors.forEach(function (element) {
          element.ismodified = false
        })

        state.reservation.mainguest.ismodified = false
        if (i >= 0) {
          guest = state.reservation.visitors[i]
          guest.ismodified = true
          state.schedaospitevisibile = true
          state.reservation.visitors.splice(i, 1, guest)
          console.log('ASSEGNO MODIFICATO', i)
        }
      }
    },
    editMainGuest(state, ) {
      state.reservation.visitors.forEach(function (element) {
        element.ismodified = false
      })
      state.schedaospitevisibile = true
      Object.assign(state.reservation.mainguest, { 'ismodified': true })
    },
    addGuest(state, roomid) {

      var newuser = null;
      console.log("addguest", roomid)
      var trovato = false
      // this.alldata.reservation.visitors.splice(1, 1)
      // this.alldata.reservation.visitors.push(newuser)
      if (newuser) {
        console.log('Cerco...', newuser)
        var i = state.reservation.visitors.findIndex(x => x.id === newuser.id)
        console.log('TROVATO', i)
        state.reservation.visitors.splice(i, 1, newuser)
        // this.alldata.reservation.visitors.push(newuser)
        trovato = true
      }
      if (!trovato) {
        state.count++
        state.reservation.visitors.push({
          firstName: 'nuovo',
          lastName: 'guest',
          image: 'static/img/faces/face-0.jpg',
          gender: 'M',
          ismodified: true,
          iscompiled: false,
          roomid: roomid,
          id: state.count++
        })
      } else {
      }
    },
    decrement: state => state.count--
  },
  getters: {
    getCurrentLan: state => state.currentlan,
    currentconfig(state) {
      var ret ='xjyz'
      state.config2.forEach(ele => {
        console.log("current_conf",state.currentlan,ele.LINGUA.toLowerCase(),ele)
        if(ele.LINGUA.toLowerCase() === state.currentlan){
          console.log("restituisco ",ele)
          ret = ele
        }
      });
      return ret
    },
    user(state) {
      return state.firebaseuser
    },
    reservationid(state) {
      var s = localStorage.getItem('reservationid')
      if (state.reservation._id) {
        return state.reservation._id
      }
      else if (s) {
        return s
      }
      else {
        return null
      }

    },
    fcmtoken(state) {
      return state.fcmtoken;
    },
    privacyfinalita(state) {
      
      let lingua =state.currentlan
      console.log("privacy",lingua)
      if(!state.currentlan){
        lingua ='it'
      }
      for (let index = 0; index < state.config2.length; index++) {
        const element = state.config2[index];
        if(element.LINGUA.toLowerCase() == lingua.toLowerCase()){
          return element.ListaPrivacy
        }
        
      }
      return [];
    },

  }
})

initFirebase()
  .catch(error => {
    console.log(error)
    // take user to a page stating an error occurred
    // (might be a connection error, or the app is open in another tab)
  }).then(function () {

    console.log("Utente loggato:", Firebase.auth().currentUser)
    if (!Firebase.auth().currentUser) {
      console.log("Eseguo Login Anonimo")
      Firebase.auth().signInAnonymously().then(function () {

        let b = Firebase.messaging.isSupported();
        console.log("inizializzo messaging")
        if (b) {
          console.log("inizializzo in corso..")
           const messaging = Firebase.messaging();
          messaging.requestPermission().
          then(() => {
            console.log('Notification permission granted.x');
      
            // Get Token
            messaging.getToken()
              .then((token) => {
                console.log("FCMTOKEN:", token)
                  store.dispatch("updateFcmToken", token)
                    .then()
                    .catch(err => {
                      console.error('errore dispatch FCM', err)
                    })
                    
                    
              })
              .catch(err => {
                console.error('errore FCM', err)
              })
          })
          .catch((err) => {
            console.log('Unable to get permission to notify.', err);
          });
        }
  
  
        /*
        var credential = Firebase.auth.EmailAuthProvider.credential('pippo@prov.it', "PWD-4353,64d2")
        console.log(credential);
        Firebase.auth().currentUser.linkWithCredential(credential)
        .then(function(usercred) {
            var user = usercred.user;
            console.log("Anonymous account successfully upgraded", user);
        }).catch(function(error) {
            console.log("Error upgrading anonymous account", error);
        });
        */
      })
        .catch(function (error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log(errorCode, errorMessage)
          // ...
        });
    }
    else{
      console.log("Utente già loggato,", Firebase.auth().currentUser)
    }


    Firebase.auth().onAuthStateChanged(function (user) {

      store.dispatch("fetchUser", user);
      /*
      if (user) {
        // User is signed in.
        var isAnonymous = user.isAnonymous;
        var uid = user.uid;
        // ...
      } else {
        // User is signed out.
        // ...
      }
      */
    });
  })


export default store;